// Install-time parameters — in the real build the HOST (Kreta) passes these
// when mounting Jigyasa (locked in jigyasa_integration_contract.md §E,
// Round-trip 4, 11 Jun 2026). For the Phase A demo they are hardcoded to the
// pilot's values.
export const INSTALL_PARAMS = {
  costumeId: "coworking_v1",
  allowRoleToggle: true,
  enableOperatorPhone: false, // pilot: operator works on desktop only
  lookupTrigger: "button",    // pilot: Kreta house style (phone-first + explicit Search).
                              // Engine default is 'auto' — see Round-trip 10.
};
